import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
    InputAdornment,
    Typography,
    IconButton,
    Autocomplete,
    Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const WalletTopupDialog = ({
    open,
    onClose,
    topupAmount,
    setTopupAmount,
    topupFile,
    handleFileChange,
    onConfirm,
    amountError,
    fileError,
    showUserSelect = false,
    userList = [],
    selectedUser = null,
    handleUserChange = () => { },
    userError = "",
}) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: "16px",
                    overflow: "hidden",
                },
            }}
        >
            <DialogTitle
                sx={{
                    background: "linear-gradient(135deg, #1E3A5F 0%, #2E5A8F 100%)",
                    color: "#fff",
                    fontFamily: "Inter",
                    fontWeight: 600,
                    fontSize: "20px",
                    padding: "20px 24px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                }}
            >
                <Typography sx={{ fontFamily: "Inter", fontWeight: 600, fontSize: "20px" }}>
                    Wallet Top-up
                </Typography>
                <IconButton onClick={onClose} sx={{ color: "#fff" }}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent sx={{ padding: "32px 24px" }}>
                {showUserSelect && (
                    <>
                        <Typography
                            sx={{
                                fontFamily: "Inter",
                                fontSize: "14px",
                                color: "#667085",
                                marginBottom: "8px",
                            }}
                        >
                            Select User <span style={{ color: "#D32F2F" }}>*</span>
                        </Typography>
                        <Autocomplete
                            options={userList}
                            value={selectedUser}
                            onChange={handleUserChange}
                            getOptionLabel={(option) => option.label || option.name || ""}
                            isOptionEqualToValue={(option, value) => option._id === value._id}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    placeholder="Search User"
                                    sx={{
                                        "& .MuiOutlinedInput-root": {
                                            fontFamily: "Inter",
                                            fontSize: "16px",
                                            borderRadius: "8px",
                                            "& fieldset": {
                                                borderColor: "#667085 !important",
                                                borderWidth: "0.5px !important",
                                                borderStyle: "solid !important",
                                            },
                                            "&:hover fieldset": {
                                                borderColor: "#1E3A5F !important",
                                                borderWidth: "1px !important",
                                            },
                                            "&.Mui-focused fieldset": {
                                                borderColor: "#1E3A5F !important",
                                                borderWidth: "1.5px !important",
                                            },
                                        },
                                    }}
                                />
                            )}
                        />
                        {userError && (
                            <Typography
                                sx={{
                                    fontFamily: "Inter",
                                    fontSize: "12px",
                                    color: "#D32F2F",
                                    marginTop: "4px"
                                }}
                            >
                                {userError}
                            </Typography>
                        )}
                        <Box sx={{ mt: 3 }} />
                    </>
                )}
                <Typography
                    sx={{
                        fontFamily: "Inter",
                        fontSize: "14px",
                        color: "#667085",
                        marginBottom: "16px",
                    }}
                >
                    Enter the amount you want to add to your wallet and upload a receipt
                </Typography>
                <TextField
                    margin="dense"
                    label="Amount"
                    autoFocus
                    fullWidth
                    type="number"
                    placeholder="Enter amount"
                    value={topupAmount}
                    onChange={(e) => setTopupAmount(e.target.value)}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <Typography sx={{ fontFamily: "Inter", fontWeight: 600, color: "#1E3A5F" }}>
                                    ₹
                                </Typography>
                            </InputAdornment>
                        ),
                    }}
                    sx={{
                        "& .MuiOutlinedInput-root": {
                            fontFamily: "Inter",
                            fontSize: "16px",
                            borderRadius: "8px",
                            // border: "1px solid #667085 !important",
                            "& fieldset": {
                                borderColor: "#667085 !important",
                                borderWidth: "0.5px !important",
                                borderStyle: "solid !important",
                            },
                            "&:hover fieldset": {
                                borderColor: "#1E3A5F !important",
                                borderWidth: "1px !important",
                            },
                            "&.Mui-focused fieldset": {
                                borderColor: "#1E3A5F !important",
                                borderWidth: "1.5px !important",
                            },
                        },
                    }}
                />
                {amountError && (
                    <Typography
                        sx={{
                            fontFamily: "Inter",
                            fontSize: "12px",
                            color: "#D32F2F",
                            marginTop: "4px",
                        }}
                    >
                        {amountError}
                    </Typography>
                )}

                <Typography
                    sx={{
                        fontFamily: "Inter",
                        fontSize: "14px",
                        color: "#667085",
                        marginTop: "24px",
                        marginBottom: "8px",
                    }}
                >
                    Upload Receipt/Proof of Payment *
                </Typography>
                <Button
                    component="label"
                    fullWidth
                    sx={{
                        textTransform: "none",
                        fontFamily: "Inter",
                        padding: "12px 16px",
                        borderRadius: "8px",
                        border: "1.5px dashed #D0D5DD",
                        color: "#667085",
                        backgroundColor: "#F9FAFB",
                        "&:hover": {
                            backgroundColor: "#F3F4F6",
                            border: "1.5px dashed #1E3A5F",
                        },
                    }}
                >
                    <input
                        type="file"
                        hidden
                        accept="image/*,.pdf"
                        onChange={handleFileChange}
                    />
                    {topupFile ? topupFile.name : "Choose File (Images or PDF)"}
                </Button>
                {topupFile && (
                    <Typography
                        sx={{
                            fontFamily: "Inter",
                            fontSize: "12px",
                            color: "#2E7D32",
                            marginTop: "8px",
                        }}
                    >
                        ✓ File selected: {topupFile.name} ({(topupFile.size / 1024).toFixed(2)} KB)
                    </Typography>
                )}
                {fileError && (
                    <Typography
                        sx={{
                            fontFamily: "Inter",
                            fontSize: "12px",
                            color: "#D32F2F",
                            marginTop: "8px",
                        }}
                    >
                        {fileError}
                    </Typography>
                )}
            </DialogContent>
            <DialogActions sx={{ padding: "16px 24px 24px", gap: "12px", justifyContent: "center" }}>
                <Button
                    onClick={onClose}
                    sx={{
                        textTransform: "none",
                        fontFamily: "Inter",
                        fontWeight: 500,
                        padding: "10px 24px",
                        borderRadius: "8px",
                        border: "1px solid #D0D5DD",
                        color: "#667085",
                        "&:hover": {
                            backgroundColor: "#F9FAFB",
                        },
                    }}
                >
                    Cancel
                </Button>
                <Button
                    onClick={onConfirm}
                    sx={{
                        textTransform: "none",
                        fontFamily: "Inter",
                        fontWeight: 500,
                        padding: "10px 24px",
                        borderRadius: "8px",
                        background: "linear-gradient(135deg, #1E3A5F 0%, #2E5A8F 100%)",
                        color: "#fff",
                        "&:hover": {
                            background: "linear-gradient(135deg, #2E5A8F 0%, #1E3A5F 100%)",
                        },
                    }}
                >
                    Top Up
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default WalletTopupDialog;
